import {Button} from '@mui/material';
import {EmptySearchState as EmptySearchStateGlobal} from 'presentation/components';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {EmptySearchStateType} from './types';

const {clearFilters} = translations['pt-br'].commons;

export const EmptySearchState = ({title, description, clearFilter}: EmptySearchStateType) => {
	const {isMobile} = useMediaQueries();
	return (
		<EmptySearchStateGlobal
			title={title}
			description={description}
			noMarginImage={!isMobile}
			customMaxWidthCard={'100%'}
			customMargin="0"
			customJustifyContent="center"
			sx={{justifyContent: 'center', textAlign: isMobile ? 'center' : 'left'}}>
			{clearFilter ? (
				<Button size="large" variant="outlined" onClick={clearFilter}>
					{clearFilters}
				</Button>
			) : null}
		</EmptySearchStateGlobal>
	);
};
